import moment from 'moment';
class liquidation {
    constructor(
        id,
        name,
        description,
        from,
        to,
        state,
        modelId,
        modelName,
        hasInterface,
        detailsQuantity,
        canDoInterface,
        canSign,
        canRetire
        )
         {

        this.id = id
        this.name = name
        this.from =  moment(from).utc().format("DD-MM-YYYY")
        this.to =  moment(to).utc().format("DD-MM-YYYY")
        this.description =description;
        this.state = state
        this.modelId = modelId
        this.modelName = modelName
        this.hasInterface = hasInterface == true ? '✔️' : ''
        this.detailsQuantity = detailsQuantity
        this.canDoInterface = canDoInterface
        this.canSign = canSign
        this.canRetire = canRetire
      
    }
    static fromJson({
        liqId,
        nombre,
        descripcion,
        fecDesde,
        fecHasta,
        estado,
        modeloId,
        modeloNombre,
        tieneInterfaz,
        cantidadDetalle,
        puedeRealizarInterfaz,
        puedeFirmar,
        puedeRetirar
}) {
        return new liquidation(
            liqId,
            nombre,
            descripcion,
            fecDesde,
            fecHasta,
            estado,
            modeloId,
            modeloNombre,
            tieneInterfaz,
            cantidadDetalle,
            puedeRealizarInterfaz,
            puedeFirmar,
            puedeRetirar
            );
    }
}
export default liquidation;
